import { render, staticRenderFns } from "./PromotionPreviewSmallDetails.vue?vue&type=template&id=208e09f2"
import script from "./PromotionPreviewSmallDetails.vue?vue&type=script&lang=js"
export * from "./PromotionPreviewSmallDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports